<template>
  <div :class="this.cardClass() + ' markdown px-3'" id='panel-text' @click="handleClick">
    <pre class="mb-3" style="font-family: inherit; color: inherit;" wrap>
      <mrx-translation :token="markdown" :renderAsHTML="true"></mrx-translation>
    </pre>
  </div>
</template>

<script>
  import languageLogic from '@/mixins/languageLogic'
  import ui from '@/mixins/ui'
  import { usePreferenceStore } from '@/stores/preference'
  import { genericEvent } from '@/utils/collectUpload'

  export default {
    mixins: [languageLogic, ui],
    name: 'markdown',
    data() {
      return {}
    },
    model: {
      prop: 'items',
      event: 'click'
    },
    props: {
      panelName: String,
      options: Object,
      items: Array
    },
    methods: {
      async handleClick(e) {
        if (e.target.localName === 'a') {
          await genericEvent({
            name: 'markdownLinkSelected',
            data: { tag: e.target.id, panel: this.panelName },
            additions: ['encounterId']
          })
        }
      }
    },
    computed: {
      markdown() {
        if (this.options.base_text_off_panel) {
          try {
            const p = usePreferenceStore().get(this.options.base_text_off_panel)
            let selected = p.responses.find(r => r.selected).value
            let token = `questions.${this.panelName}.${selected}.text`
            if (this.$te(token, this.$i18n.fallbackLocale)) return token
          }
          catch (e) {}
        }
        return `questions.${this.panelName}.text`
      },
      response() {
        return this.items[0]
      }
    },
    mounted() {
      this.response.selected = true
    },
    watch: {
      panelName: {
        handler(val) {
          this.response.selected = true
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>
